import { Box, Divider, Paper, Stack, styled, Typography } from '@mui/material';
import { Message } from '../types';
import AudioPlayer from './AudioPlayer';

const MessageContainer = styled(Box, {
	shouldForwardProp: (prop: string) => !['isRight'].includes(prop),
})<{ isRight?: boolean }>(({ theme, isRight }) => ({
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	alignItems: isRight ? 'flex-end' : 'flex-start',
	textAlign: isRight ? 'right' : 'left',

	'.sender-name': {
		[isRight ? 'marginRight' : 'marginLeft']: theme.spacing(1),
		marginBottom: 1,
	},

	'.window': {
		background: theme.palette.background.default,
		padding: theme.spacing(1),
		maxWidth: '70%',

		...(isRight
			? {
					width: '100%',
					borderTopRightRadius: 0,
			  }
			: {
					borderTopLeftRadius: 0,
			  }),

		[theme.breakpoints.down('sm')]: {
			maxWidth: '90%',
		},
	},

	'.text-prefix': {
		width: 3,
		borderLeftColor: theme.palette.divider,
		borderLeftWidth: 3,
		borderLeftStyle: 'solid',
	},

	'.text': {
		...(isRight && {
			color: theme.palette.text.secondary,
			fontSize: '0.9rem',
			fontStyle: 'italic',
		}),
	},
}));

interface Props {
	message: Message;
}

export default function MessageBox({
	message: { senderName, assetURL, id, text, isRight },
}: Props) {
	return (
		<MessageContainer isRight={isRight}>
			<Typography variant="body2" className="sender-name">
				{senderName}
			</Typography>
			<Paper className="window" elevation={0}>
				{isRight && assetURL && (
					<Box mb={0.5}>
						<AudioPlayer src={assetURL} />
					</Box>
				)}

				<Stack
					direction="row"
					spacing={1}
					justifyContent={isRight ? 'flex-end' : 'flex-start'}
				>
					<Typography className="text">{text}</Typography>
					{isRight && <Box className="text-prefix" />}
				</Stack>
			</Paper>
		</MessageContainer>
	);
}
